/*
 * URL del backend, en un solo sitio.
 *
 * Antes cada página (portada, precios, gracias) llevaba su propia copia de esta función y
 * los componentes la recibían por props. Un cambio de dominio del backend había que
 * hacerlo en cuatro ficheros.
 */
export function getApiUrl() {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') return 'http://localhost:5987';
  return 'https://nomina-backend-production-57d2.up.railway.app';
}
